module.exports = __webpack_public_path__ + "static/media/icon-dashboard-commissions-earned.50307681.svg";